if (!customElements.get('announcement-rotator')) {
  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.announcement-rotator__item'));
      if (this.items.length < 2) return;

      this.index = Math.max(
        this.items.findIndex((item) => item.classList.contains('is-active')),
        0
      );
      this.speed = (parseInt(this.dataset.speed, 10) || 3) * 1000;

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      // Theme editor: show the selected announcement block.
      document.addEventListener('shopify:block:select', (event) => {
        const position = this.items.indexOf(event.target.closest('.announcement-rotator__item'));
        if (position === -1) return;
        this.stop();
        this.show(position);
      });
      document.addEventListener('shopify:block:deselect', () => this.start());

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.show((this.index + 1) % this.items.length), this.speed);
    }

    stop() {
      clearInterval(this.timer);
    }

    show(position) {
      this.items[this.index].classList.remove('is-active');
      this.items[this.index].setAttribute('aria-hidden', 'true');
      this.index = position;
      this.items[this.index].classList.add('is-active');
      this.items[this.index].removeAttribute('aria-hidden');
    }
  }

  customElements.define('announcement-rotator', AnnouncementRotator);
}
